import React, { Component } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import PropTypes from 'prop-types';


class BoolModelMeasurement extends Component {
  render() {
    const { measurementKey, modelMeasurement, handleModelMeasurementChange, inEditMode } = this.props;

    return (
      <FormGroup row className="center">
        <FormControlLabel
          disabled={!inEditMode}
          control={
            <Checkbox
              checked={
                modelMeasurement[measurementKey] || false
              }
              color="secondary"
              onChange={() =>
                handleModelMeasurementChange(
                  {[measurementKey]:!modelMeasurement[measurementKey]},
                  measurementKey
                )
              }
            />
          }
        />
      </FormGroup>
    )
  }
}

BoolModelMeasurement.propTypes = {
  measurementKey: PropTypes.string.isRequired,
  inEditMode: PropTypes.bool.isRequired,
  modelMeasurement: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any, PropTypes.number, PropTypes.bool])).isRequired,
  handleModelMeasurementChange: PropTypes.func.isRequired,
}

export default BoolModelMeasurement;